import {LookUpModalActionButtonOption} from "../../data_set/LookUp.model";

export const ModalCloseOptionKeyConstant = "modalCloseOption";

export const ModalCloseOptionConstant = {
    label: "Modal Action",
    value: null,
    description: "Modal action associated with button",
    lookUpData: LookUpModalActionButtonOption
};